import axios from 'axios'
import config from './config.js'
import router from '../router/index.js'
import notice from '../assets/js/notice.js'
import {
  Indicator,
  
} from 'mint-ui';
import configFile from './configFile.js';
import configUser from './configUser.js';

// http响应拦截
axios.interceptors.request.use(
  config => {
    const token = window.localStorage.getItem('token') || ''
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${token}`
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
axios.interceptors.response.use(
  response => {
    if (response.data.errCode === 401) {
      router.push({
        name: 'login'
      })
      notice.tip('您未授权使用此应用')
      Indicator.close()
      return Promise.reject(response.data.errCode)
    } else {
      return Promise.resolve(response.data)
    }
  },
  error => {
    Indicator.close()
    return Promise.reject(error)
  }
);

export default {




    //首页 数据
    getHomePageData(data) {
      return axios.post('mbph/mobile/index/all', data, config)
    },
  //首页 各区域本月签约金额占比
  getHomePagePie(data) {
    return axios.post('mbph/mobile/index/region', data, config)
  },
  //首页 发票待回款数据
  getHaveWaitMoney(data) {
    return axios.post('mbph/mobile/index/haveWaitMoney', data, config)
  },
  //首页 各制作部月度交付项目数与项目金额（显示柱形图所需数据）
  getHomePageDelivery(data) {
    return axios.post('mbph/mobile/index/delivery', data, config)
  },
  // 首页 各制作部门产值占比
  getHomepageGroupValue(data) {
    return axios.post('mbph/mobile/index/amoeba', data, config)
  },
  // 首页 各制作部门人均产值对比
  getHomePageAVGValue(data) {
    return axios.post('dashboard/boss/bus/AVGValue', data, config)
  },


  //首页钻取
  //签约金额钻取数据
  getHomePageSignDrill(data) {
    return axios.post('mbph/mobile/index/signMoney', data, config)
  },
  //回款金额钻取数据
  getHomePageBackDrill(data) {
    return axios.post('mbph/mobile/index/backMoney', data, config)
  },
  //首页与交付金额钻取数据
  getHomePageDeliveryDrill(data) {
    return axios.post('mbph/mobile/index/deliveryMoney', data, config)
  },
  // 首页已开发票待回款金额钻取数据
  getHomepageInvoicedReturnDrill(data) {
    return axios.post('mbph/mobile/index/haveWaitMoney', data, config)
  },
  // 首页未开发票待回款金额钻取数据中
  getHomepageNoInvoicedReturnDrill(data) {
    return axios.post('mbph/mobile/index/noWaitMoney', data, config)
  },
  // 首页环形图各区域回款钻取数据 与分析业务屏一样
  getRegionBackDrill(data) {
    return axios.post('mbph/mobile/bus/regionMoney', data, config)
  },

  // 获取未读数
  getNoReadNum(data) {
    return axios.post('mbph/mobile/know/note', data, config)
  },


  // 案例大全
  getCaseList() {
    return axios.post('mbph/case/caseListMobile', {}, config)
  },
  // 案例大全 搜索
  serchCase(data) {
    return axios.post('mbph/case/caseListMobile', data, config)
  },
  //案例大全 获取搜索列表
  getSearchList() {
    return axios.post('mbph/case/searchCondition', {}, config)
  },
  // 回款排名和销售额排名数据
  getSaleSort(data) {
    return axios.post('mbph/mobile/getSaleSort', data, config)
  },
  //全部销售回款排行
  getBackRankSort(data) {
    return axios.post(`mbph/mobile/getBackRankSort`, data, config)
  },
  //全部销售签约排行
  getSaleRankSort(data) {
    return axios.post(`mbph/mobile/getSaleRankSort`, data, config)
  },

  // 获取销售详情数据
  getSalesDetail(data) {
    return axios.post('mbph/mobile/sale/saleInfo', data, config)
  },
  // 获取销售详情预警项目
  getSaleAlertList(data) {
    return axios.post('mbph/mobile/sale/alertList', data, config)
  },
  //获取销售详情个人项目
  getSaleOrderList(data) {
    return axios.post('mbph/mobile/sale/orderList', data, config)
  },
  //获取销售个人回款
  getSaleBackList(data) {
    return axios.post('mbph/mobile/sale/backList', data, config)
  },

  // //查看销售详情
  // getSaleDetail (data) {
  //   return axios.post('mbph/mobile/getSaleMoneyDetail', data , config)
  // },
  // //查看回款详情
  // getBackDetail (data) {
  //   return axios.post('mbph/mobile/getBackMoneyDetail', data , config)
  // },


  //分析 业务
  getBusiness(data) {
    return axios.post('mbph/mobile/getYewuStatisticData', data, config)
  },
  //分析 业务 回款预警项目
  getBusinessAlert(data) {
    return axios.post('mbph/mobile/bus/getAlert', data, config)
  },
  //分析 业务 已签约数据钻取
  getBusinessSignDrill(data) {
    return axios.post('mbph/mobile/bus/signMoney', data, config)
  },
  //分析 业务 已交付待回款金额钻取数据
  getBusinessHasOkWaitMoneyDrill(data) {
    return axios.post('mbph/mobile/bus/deliveryMoney', data, config)
  },
  //分析 业务 已签约待回款钻取数据
  getBusinessHasContractWaitMoneyDrill(data) {
    return axios.post('mbph/mobile/bus/deliveryWaitMoney', data, config)
  },
  //分析 业务 已开发票待回款金额钻取数据
  getBusinessHasInvoiceWaitMoneyDrill(data) {
    return axios.post('mbph/mobile/bus/haveWaitMoney', data, config)
  },
  //分析 业务 签约金额图表和签约数目钻取数据
  // getBusinessEchartsDrill (data) {
  //   return axios.post('mbph/mobile/bus/signMoney',  data , config)
  // },

  //分析 业务 月份
  getPieChart(data) {
    return axios.post('mbph/mobile/getPieChart', data, config)
  },
  //分析 业务 年度
  getLineChart() {
    return axios.post('mbph/mobile/getLineChart', {}, config)
  },
  //分析 业务 年度
  getZhuChart() {
    return axios.post('mbph/mobile/getZhuChart', {}, config)
  },
  //业务数据明细
  getMakeInfo(data) {
    return axios.post('mbph/mobile/getMakeInfo', data, config)
  },
  getLetter(path) {
    return axios.post('mbph/mobile/getUpyunFile', {
      path: path
    }, config)
  },



  //分析 阿米巴 阿米巴项目对比
  getProjectContrast(data) {
    return axios.post('mbph/mobile/analyze/amoeba', data, config)
  },
  //分析 阿米巴 制作部对比
  getMakeContrast(date) {
    return axios.post('mbph/mobile/analyze/group', {
      date: date
    }, config)
  },
  //分析 阿米巴 阿米巴小组对比数据
  getAmoebaContrast(data) {
    return axios.post('mbph/mobile/analyze/item', data, config)
  },




  //分析 制作
  getMake(data) {
    return axios.post('mbph/mobile/analyze/project', data, config)
  },
  // 分析 制作 两个饼图
  getMakeChartsData(data) {
    return axios.post('mbph/mobile/analyze/barLine', data, config)
  },
  //分析 制作 已回款金额钻取
  getMakeBackDrill(data) {
    return axios.post('mbph/mobile/analyze/backMoney', data, config)
  },
  //分析 制作 开发票待回款金额钻取
  getMakeInvoiceNoBack(data) {
    return axios.post('mbph/mobile/analyze/haveWaitMoney', data, config)
  },
  //分析 制作 交付金额钻取
  getMakeDeliverMoney(data) {
    return axios.post('mbph/mobile/analyze/payMoney', data, config)
  },
  //分析 制作 新增项目数钻取
  getMakeNewProjectNum(data) {
    return axios.post('mbph/mobile/analyze/newProjectNum', data, config)
  },
  //分析 制作 正在开发项目数钻取
  getMakeDoProjectNum(data) {
    return axios.post('mbph/mobile/analyze/doProjectNum', data, config)
  },
  //分析 制作 需交付项目数钻取
  getMakeNeedPayNum(data) {
    return axios.post('mbph/mobile/analyze/needPayNum', data, config)
  },




  //我的项目
  getMyProject() {
    return axios.post('mbph/mobile/project/index', {}, config)
  },
  //我的阿米巴
  getMyAmoeba() {
    return axios.post('mbph/mobile/project/amoeba', {}, config)
  },
  //查看 交付计划
  getDeliverPlan(id) {
    return axios.post(`mbph/mobile/project/payment/${id}`, {}, config)
  },
  //查看合同
  getContract(id) {
    return axios.post(`mbph/mobile/project/contract/${id}`, {}, config)
  },



  //我 获取我的信息
  getMyData() {
    return axios.post('mbph/personal/personInfo', {}, config)
  },
  //我 获取个人消息
  getMyMsg() {
    return axios.post('mbph/personal/personMsg', {}, config)
  },
  // 我 我的消息 点击改变状态
  getChangStatus(id) {
    return axios.post('mbph/personal/updatePersonMsg', {
      id: id
    }, config)
  },
  //我 获取我的任务
  getMyMisson() {
    return axios.post('mbph/personal/personTask', {}, config)
  },

  // 销售业绩
  getUserList(id) { //获取销售 以及旗下销售列表
    return axios.post('mbph/mobile/saleUsers', {
      id: id
    }, config)
  },
  getSaleData(data) {
    return axios.post('mbph/mobile/getSaleStatisticData', data, config)
  },
  //获取销售个人回款预警数据接口
  getSaleAlert(data) {
    return axios.post('mbph/mobile/sale/alertList', data, config)
  },


  // 绑定手机号
  bindUser(data) {
    return axios.post('bind/wechat', data, configUser)
  },
  // 获取用户信息
  getUserInfo(data) {
    return axios.post('user', data, configUser)
  },

  // 知识库列表
  getKnowledgeList(type = '',column = '') {
    return axios.post('mbph/mobile/know/index', {
      type: type,
      column:column
    }, config)
  },
  // 获取知识库详情
  getDetailKnow(id) {
    return axios.post('mbph/mobile/know/detail', {
      id: id
    }, config)
  },
  // 更改知识库的 赞同 反对 收藏的接口
  updataKnowState(data) {
    return axios.post('mbph/mobile/know/update', data, config)
  },

  //首页6个钻取详情页面接口mbph/project/detail
  getProDetail(data) {
    return axios.post('mbph/project/detail', data, config)
  },
  getPrologs(data) { //日志
    return axios.post('mbph/task/logs', data, config)
  },

  //我的页面 开票申请页面的列表页/mbph/mobile/invoicing/index
  getOpenTicketListdata(data) { //
    return axios.post('mbph/mobile/invoicing/index', data, config)
  },
  //我的页面删除项目 接口 /mbph/mobile/invoicing/remove
  getInvoicingRemove(data) {
    return axios.post('mbph/mobile/invoicing/remove', data, config)
  },
  //我的页面，开票编辑和新建接口/mbph/mobile/invoicing/edit
  getInvoicingEdit(data) {
    return axios.post('mbph/mobile/invoicing/edit', data, config)
  },
  //开票保存接口/mbph/mobile/invoicing/store
  getInvoicingStore(data) { //http://192.168.80.207:8003/mbph/mobile/invoicing/store
    return axios.post('mbph/mobile/invoicing/store', data, config)
  },
  //开票申请提交按钮/mbph/mobile/invoicing/commit
  getInvoicingCommit(data) { //http://192.168.80.207:8003/mbph/mobile/invoicing/store
    return axios.post('/mbph/mobile/invoicing/commit', data, config)
  },
  //搜索项目接口mbph/project/search
  getProSearch(data) {
    return axios.post('mbph/project/search', data, config)
  },
  //微信jssdk
  getWechatSignatures() {
    // return axios.post('mbph/mobile/auth/getSDK',url,config)
    return axios.get(`mbph/mobile/auth/getSDK?url=${encodeURIComponent(location.href.split('#')[0])}`, config)

  },
  //mbph/mobile/invoicing/analysis
  getInvoiceanalysis(data) {
    return axios.post('mbph/mobile/invoicing/analysis', data, config)

  },
  /**************bug反馈接口**************/
  // 获取bug列表
  getBugList(data) {
    return axios.post('/chandao/bug/bugList', data, config)
  },

  // 根据产品id获取信息
  getAddView(data) {
    return axios.post('/chandao/bug/addView', data, config)
  },
  // 提交bug
  addBug(data) {
    return axios.post('chandao/bug/submit', data, config)
  },
  //bug详情chandao/bug/detail
  getBugDetail(data) {
    return axios.post('chandao/bug/detail', data, config)
  },
  //bug历史记录/chandao/bug/history
  getBugHistory(data) {
    return axios.post('chandao/bug/history', data, config)
  },
  //添加留言/chandao/bug/message
  getMessage(data) {
    return axios.post('chandao/bug/message', data, config)
  },
  // 上传图片
  getUpload(data) {
    return axios.post('siwei/file/article/upload', data, configFile)
  },
  closeBug(data) {
    return axios.post('chandao/bug/close', data, config)
  },
  /******************bug反馈接口***************/
  //我的审核列表
  getExamineList(type) {
    return axios.post('mbph/personal/reviewList', {
      type
    }, config)
  },
  //我的审核详情
  getExamineDetail(id) {
    return axios.post('mbph/personal/quoteDetail', {
      id
    }, config)
  },
  //我的审核审核操作
  getupdateReview(data) {
    return axios.post('mbph/personal/updateReview', data, config)
  },
  //添加留言

  getsaveLog(data) {
    return axios.post('mbph/personal/saveLog', data, config)
  },

  // 获取案例大会的url
  getCaseUrl(data) {
    return axios.post('mbph/case/newCaseList', data, config)
  },
  /*********思为知屋分享排行模块*********/
  //分享排行
  getSharkRank(data = {}, page = 1) {
    return axios.get(`siwu/adviser_sort?day=${data.day}&sort=${data.sort}&key=${data.key}&page=${page}&limit=20`, config)
  },
  //行为轨迹
  getFootPrint(data = {}, page = 1) {
    return axios.get(`siwu/adviser_footprint?uuid=${data.uuid}&page=${page}&limit=20`, config)
  },
  //关联项目
  getRelationProject(data = {}, page = 1) {
    return axios.get(`siwu/adviser_relation_project?uuid=${data.uuid}&page=${page}&limit=20`, config)
  },
  //获取名片数据
  getAdviserVisitors(data = {}, page = 1) {
    return axios.get(`siwu/adviser_visitor?page=${page}&limit=20&sign_intention_status=${data.sign_intention_status}&day=${data.day}&uuid=${data.uuid}`, config)
  },
  /*********思为知屋分享排行模块*********/
  /**********思为知屋关联项目*************/
  getRelationPro(data = {}, page = 1) {
    return axios.get(`siwu/mobile/relationProject?page=${page}&limit=10&type=${data.type}`, config)
  },
  getProList(data, page = 1) { //项目列表
    return axios.get(`siwu/mobile/projectList?page=${page}&key=${data.key}&limit=1000`, config)
  },
  addRelation(project_code = {}) { //添加关注
    return axios.get(`siwu/mobile/addRelation?project_code=${project_code}`, config)
  },
  removeRelation(project_code = {}) { //移除关注
    return axios.get(`siwu/mobile/removeRelation?project_code=${project_code}`, config)
  },
  //获取地区的数组
  getGroups(data = {}) {
    return axios.post(`mbph/mobile/adaptor/group`, data, config)
  },
  // 获取小组数据
  getItems(data = {}) {
    return axios.post(`mbph/mobile/index/item`, data, config)
  },

  
  /**********思为知屋关联项目*************/
  
  // 获取销售列表
  getSaleListApi(data) { 
    return axios.post(`mbph/saleList`,data, config)
  },
  // 获取个人业绩
  getPerformanceApi(data) { 
    return axios.post(`mbph/personal/performance`,data, config)
  },
  // 获取个人计划初始化数据
  getPlanInfoApi(data) { 
    return axios.post(`mbph/personal/planInfo`,data, config)
  },
  // 保存个人计划数据
  postPlanInfoApi(data) { 
    return axios.post(`mbph/personal/salePlan`,data, config)
  },
  // 获取业绩趋势图
  getTendencyfoApi(data) { 
    return axios.post(`mbph/personal/tendency`,data, config)
  },
}



// WEBPACK FOOTER //
// ./src/fetch/fetch.js